import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function useVaultItemFormUpsert() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  interface VaultResponse {
    message?: string;
  }

  interface VaultData {
    dataClassUuid?: string;
    key?: string;
    data: {
      [key: string]: any;
    };
  }

  return useMutation({
    mutationFn: async (objectData: VaultData): Promise<VaultResponse> => {
      const upsertData = {
        dataClassUuid: objectData.dataClassUuid,
        key: objectData.key,
        data: objectData.data,
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/create_vault_entry`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(upsertData),
        }
      );
      const data = await response.json();

      if (!response.ok || (typeof data.code === 'number' && data.code >= 400)) {
        throw new Error(data.message || 'Failed to save vault item');
      }

      return {
        message: data.message,
      };
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([
        'objectForm'
      ]);

      queryClient.invalidateQueries([
        'userVaultOptions'
      ]);
    },
  });
}
